import { leadAssignmentRulesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LEAD_MATCH_SCHEMA_ACTION_TYPE = createNamedActions('leadMatchSchema', {
  GET_SCHEMA: 'GET_SCHEMA',
});

export const getLeadMatchSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await leadAssignmentRulesApi.getLeadMatchExpressionDefinition();

  return dispatch({
    type: LEAD_MATCH_SCHEMA_ACTION_TYPE.GET_SCHEMA,
    payload: data,
  });
});
